var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportarCinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 12.4997V14.9997H4.99967V12.4997H3.33301V14.9997C3.33301 15.9163 4.08301 16.6663 4.99967 16.6663H14.9997C15.9163 16.6663 16.6663 15.9163 16.6663 14.9997V12.4997H14.9997ZM14.1663 9.16634L12.9913 7.99134L10.833 10.1413V3.33301H9.16634V10.1413L7.00801 7.99134L5.83301 9.16634L9.99967 13.333L14.1663 9.16634Z",
    fill: "black",
    fillOpacity: 0.26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportarCinza);
export default __webpack_public_path__ + "static/media/exportarCinza.1383996f310d7d5b2cf7d85ff9ec895c.svg";
export { ForwardRef as ReactComponent };